"use client";

import Link from "next/link";
import { Search, X } from "lucide-react";

import { useState,useEffect } from "react";
import { useRouter } from "next/navigation";
import Icon from "@/components/ui/icon";
import type { Category } from "@/types/category";
import { NavigationItem } from "@/types/header";

interface MenuMobileProps {
    navigation: NavigationItem[];
    mobileMenuOpen: boolean;
    setMobileMenuOpen: (open: boolean) => void;
    categories: Category[];
}

const MenuMobile = ({
                        categories = [],
                        navigation,
                        mobileMenuOpen,
                        setMobileMenuOpen,
                    }: MenuMobileProps) => {

    const parentCategories = categories
        .filter((cat) => cat.parent_id === 0)
        .sort((a, b) => a.order! - b.order!);

    const router = useRouter();
    const [searchQuery, setSearchQuery] = useState("");

    const handleSearch = () => {
        if (!searchQuery.trim()) return;

        router.push(`/search?keyword=${encodeURIComponent(searchQuery.trim())}`);
        setMobileMenuOpen(false); // بستن منو بعد از جستجو
    };

    useEffect(() => {
        if (mobileMenuOpen) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [mobileMenuOpen]);


    return (
        <>
            {/* ===== Backdrop ===== */}
            <div
                onClick={() => setMobileMenuOpen(false)}
                className={`fixed inset-0 bg-black/40 z-40 transition-opacity duration-300 ${
                    mobileMenuOpen ? "opacity-100 visible" : "opacity-0 invisible"
                }`}
            />

            {/* ===== Drawer ===== */}
            <div className={`fixed top-0 right-0 h-full w-64 bg-white z-50 shadow-xl  transform transition-transform duration-300 ease-in-out  ${mobileMenuOpen ? "translate-x-0" : "translate-x-full"}  overflow-y-auto`} >

                {/* Header */}
                <div className="flex items-center justify-between px-4 py-5 bg-gray-100">
                    <span className="font-semibold text-gray-800">
                        <Icon class_name="filter-black w-auto h-12 dark:brightness-0 dark:invert" data={`${process.env.NEXT_PUBLIC_STORAGE_UPLOADS_ASSETS_IMG}/logo/logo.svg`}/>
                    </span>
                    <button className={'cursor-pointer p-2 hover:bg-gray-300 rounded-lg'}
                            title={'بستن منو'}
                            onClick={() => setMobileMenuOpen(false)}>
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <div className="space-y-6">

                    {/* ===== جستجو ===== */}
                    <div className={'p-4 mb-0'}>
                        <div className="relative">
                            <button
                                onClick={handleSearch}
                                aria-label="جستجو"
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-primary transition-colors"
                            >
                                <Search className="w-4 h-4" />
                            </button>

                            <input
                                type="text"
                                placeholder="جستجو..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") handleSearch();
                                }}
                                className="w-full pr-10 pl-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary"
                            />
                        </div>
                    </div>

                    {/* ===== دسته‌بندی‌ها ===== */}
                    {parentCategories.length > 0 && (
                        <nav className="space-y-3 m-0">
                            {parentCategories.map((cat) => (
                                <Link
                                    key={cat.id}
                                    href={`/${process.env.NEXT_PUBLIC_SHOP_CATEGORY}/${cat.slug}`}
                                    className="block text-gray-700 hover:text-primary transition-colors hover:bg-gray-200/70 px-3 py-2 m-0"
                                    onClick={() => setMobileMenuOpen(false)}
                                    title={cat.title}
                                    prefetch={true}
                                >
                                    <span className="flex gap-2">
                                                {cat.primary_image && (
                                                    <Icon
                                                        class_name="filter-black w-7 h-7"
                                                        data={`${process.env.NEXT_PUBLIC_STORAGE_UPLOADS_ASSETS_IMG}/menu/${cat.primary_image}`}
                                                    />
                                                )}
                                        {cat.title}
                                    </span>
                                </Link>
                            ))}
                        </nav>
                    )}

                    <div className="relative px-6 py-5 m-0 before:content-[''] before:bg-gray-300 before:rounded-2xl before:absolute before:m-auto before:right-0  before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-1/2 before:h-0.5"></div>

                    {/* ===== منوهای اصلی ===== */}
                    <nav className="space-y-3 mb-12">
                        {navigation.map((item) => (
                            <Link
                                key={item.name}
                                href={item.href}
                                className="block text-gray-700 hover:text-primary transition-colors relative hover:bg-gray-200/70 px-6 py-2 m-0  before:content-[''] before:bg-blue-500 before:rounded-2xl before:absolute before:right-2 before:top-1/2 before:-translate-y-1/2 before:w-1 before:h-6"
                                onClick={() => setMobileMenuOpen(false)}
                                title={item.name}
                                prefetch={true}
                            >
                                {item.name}
                            </Link>
                        ))}
                    </nav>

                </div>
            </div>
        </>
    );
};

export default MenuMobile;
